/* eslint-disable max-classes-per-file */
export class SearchVirkesleverantorForMoveViewModel implements ISearchVirkesleverantorForMove {
    id: number;
    namn: string;
    orgnr: string;
    adress: string;
    adress2: string;
    postort: string;
    postnummer: string;
    leverantorid: string;
    klassning: string;
    fullAdress: string;
    selected: boolean;

    constructor(leverantor: ISearchVirkesleverantorForMoveBase) {
        Object.assign(this, leverantor);
        this.setFullAddress();
    }

    private setFullAddress() {
        const parts = [
            this.adress,
            this.adress2,
            this.postnummer,
            this.postort
        ];
        const usableParts = parts.filter(x => x !== null && x !== undefined && x !== "");
        this.fullAdress = usableParts.join(", ");
    }

}

export interface ISearchVirkesleverantorForMove extends ISearchVirkesleverantorForMoveBase {
    selected: boolean;
}

export interface ISearchVirkesleverantorForMoveBase {
    id: number;
    namn: string;
    orgnr: string;
    adress: string;
    adress2: string;
    postort: string;
    postnummer: string;
    leverantorid: string;
    klassning: string;
}

export class SearchVirkesleverantorForMoveResponseDTO implements ISearchVirkesleverantorForMoveBase {
    id: number;
    namn: string;
    orgnr: string;
    adress: string;
    adress2: string;
    postort: string;
    postnummer: string;
    leverantorid: string;
    klassning: string;
}

export class SearchVirkesleverantorForMoveRequestDTO {
    klassning?: string[];
    leverantorsstatus?: string;
    ansvarigVirkeskopareId: number;
}

export class MoveLeverantorerRequestDTO {
    fromAnvandareId: number;
    toAnvandareId: number;
    leverantorIds: number[];
}

export class MoveLeverantorResponseDTO {
    movedLeverantorIds: number[];
    failedMoves: MoveLeverantorFailedItemDTO[];
}

export class MoveLeverantorFailedItemDTO {
    leverantorId: number;
    limeId: string;
}
